import { ActivityLogTypeEnum } from '@/@data'
import { LiftActivityLog } from '@/components/log/LiftActivityLog'
import Link from '@/components/Link';

export const TransactionActivityLog = () => {
  const { __ } = useTranslator();

  return (
    <LiftActivityLog
      object_type={ActivityLogTypeEnum.Transaction}
      breadcrumb={
        <Link color='inherit' href='finance/transaction'>
          {__('Transaction Management')}
        </Link>
      }
    />
  )
}
